import { Link } from 'react-router-dom';

function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20Korean%20manhwa%20reading%20atmosphere%2C%20cozy%20reading%20nook%20with%20soft%20coral%20and%20cream%20gradient%2C%20abstract%20artistic%20background%20with%20gentle%20brush%20texture%2C%20comfortable%20warm%20lighting%2C%20no%20text%2C%20peaceful%20mood&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-primary-900/70"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好探索韩漫的世界了吗？
        </h2>
        <p className="text-sm md:text-base text-background-200 max-w-lg mx-auto mb-8">
          数千部高清韩国漫画等你来发现，免费阅读，随时随地畅享精彩故事
        </p>
        <Link
          to="/category/romance"
          className="inline-flex px-8 py-3 bg-accent-500 text-background-50 rounded-full font-medium text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          立即开始阅读
        </Link>
      </div>
    </section>
  );
}

export default CTASection;